import * as TYPES from './types';
import { RENEE_RECYCLE_PRODUCTS } from '~/const/product/index';
export default {
  [TYPES.SET_CURRENT_IMAGE](state, image) {
    var currentState = state;
    currentState.currentImage = image;
  },

  [TYPES.RESET_CURRENT_IMAGE](state) {
    var currentState = state;
    currentState.currentImage = null;
  },

  [TYPES.SET_PRODUCT_CAROUSELS](state, product) {
    var currentState = state;
    currentState.productCross = product.cross;
    currentState.productComplementary = product.complementary;
  },

  [TYPES.SET_PRODUCT](state, product) {
    var currentState = state;
    currentState.productCross = product.cross;
    currentState.productInspiration = product.inspiration;
    currentState.productComplementary = product.complementary;
    currentState.product = product;
    currentState.variants = product.variants || [];
    currentState.productRR = RENEE_RECYCLE_PRODUCTS.includes(product.reference);
  },

  [TYPES.SET_PRODUCT_IMAGES](state, _ref) {
    var {
      images
    } = _ref;
    state.images = images;
  },

  [TYPES.RESET_PRODUCT](state) {
    var currentState = state;
    currentState.productCross = null;
    currentState.productComplementary = null;
    currentState.productInspiration = null;
    currentState.product = null;
    currentState.images = [];
    currentState.variants = [];
    currentState.productRR = null;
  }

};